export default __webpack_public_path__ + "static/media/logo.62f59b2e.png";